import type { Theme, Components } from '@mui/material/styles';

import { varAlpha } from 'minimal-shared/utils';

// ----------------------------------------------------------------------

const MuiPaper: Components<Theme>['MuiPaper'] = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    elevation: 0,
  },
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundImage: 'none',
      backgroundColor: theme.vars.palette.background.paper,
      borderRadius: `${Number(theme.shape.borderRadius)}px`,
      variants: [
        {
          props: (props) => props.variant === 'outlined',
          style: {
            borderColor: theme.vars.palette.shared.paperOutlined,
            backgroundColor: varAlpha(theme.vars.palette.common.whiteChannel, 0.92),
            ...theme.applyStyles('dark', {
              borderColor: varAlpha(theme.vars.palette.common.whiteChannel, 0.08),
              backgroundColor: theme.vars.palette.background.neutral,
            }),
          },
        },
      ],
    }),
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const paper: Components<Theme> = {
  MuiPaper,
};
